<main class="flex">
  <app-new-sidebar class="destop-view"></app-new-sidebar>

  <div
    class="h-screen"
    id="editor"
    [ngClass]="{ 'w-screen': resultsCollapsed || innerWidth < 1360 }"
  >
    <div class="flex flex-col h-screen">
      <div class="container">
        <div class="flex items-center">
          <app-tabview-sidebar class="tab-view"></app-tabview-sidebar>
          <editor-toolbar-top></editor-toolbar-top>
        </div>
      </div>
      <div class="container">
        <div class="flex gap-default items-center p-base">
          <div class="border-none" #editorToolbar>
            <span class="has-tooltip">
              <button class="ql-bold"></button>
              <span class="tooltip-content tooltip-bottom">Bold</span>
            </span>
            <span class="has-tooltip">
              <button class="ql-italic"></button>
              <span class="tooltip-content tooltip-bottom">Italic</span>
            </span>
            <span class="has-tooltip">
              <button class="ql-underline"></button>
              <span class="tooltip-content tooltip-bottom">Underline</span>
            </span>
            <span class="has-tooltip">
              <button class="ql-header" value="1"></button>
              <span class="tooltip-content tooltip-bottom"
                >Heading Level 1</span
              >
            </span>
            <span class="has-tooltip">
              <button class="ql-header" value="2"></button>
              <span class="tooltip-content tooltip-bottom"
                >Heading Level 2</span
              >
            </span>
            <span class="has-tooltip">
              <button class="ql-align" value=""></button>
              <span class="tooltip-content tooltip-bottom">Align Left</span>
            </span>
            <span class="has-tooltip">
              <button class="ql-align" value="center"></button>
              <span class="tooltip-content tooltip-bottom">Align Center</span>
            </span>
            <span class="has-tooltip">
              <button class="ql-align" value="right"></button>
              <span class="tooltip-content tooltip-bottom">Align Right</span>
            </span>
            <span class="has-tooltip">
              <button class="ql-align" value="justify"></button>
              <span class="tooltip-content tooltip-bottom">Align Justify</span>
            </span>
            <span class="has-tooltip">
              <button class="ql-list" value="bullet"></button>
              <span class="tooltip-content tooltip-bottom">Unordered List</span>
            </span>
            <span class="has-tooltip">
              <button class="ql-list" value="ordered"></button>
              <span class="tooltip-content tooltip-bottom">Ordered List</span>
            </span>
            <span class="has-tooltip">
              <button class="ql-blockquote"></button>
              <span class="tooltip-content tooltip-bottom">Blockquote</span>
            </span>
          </div>
        </div>
      </div>
      <div
        class="output-section grid px-5 py-4 border rounded grid-cols-2 h-out-screen container"
        *ngIf="editorState.content_id"
      >
        <div class="p-base flex flex-col gap-default">
          <div>
            <section
              class="p-base border-danger rounded-lg flex items-center justify-between bg-plag"
            >
              <div>
                <h4 class="fs-6 fw-medium m-0">Plagiarised</h4>
                <p class="m-0 fs-2 fw-medium text-danger">
                  {{ editorState.score }}%
                </p>
              </div>

              <circle-progress
                [percent]="editorState.score"
                [outerStrokeWidth]="5"
                [innerStrokeWidth]="5"
                [outerStrokeColor]="'#e82d53'"
                [innerStrokeColor]="'#ffdddd'"
                [space]="-5"
                [showTitle]="false"
                [renderOnClick]="false"
                [units]="''"
                [radius]="25"
                [outerStrokeLinecap]="'square'"
              ></circle-progress>
            </section>

            <!-- <div class="flex justify-between mt-3">
            <span class="fw-medium">Exact Matched</span>
            <div>
              <span class="pill pill-warning">60%</span>
            </div>
          </div> -->

            <!-- <div class="progress-bar progress-bar-warning">
            <div class="progress-bar-fill" style="width: 60%"></div>
          </div> -->
          </div>
          <div>
            <section
              class="p-base border-primary rounded-lg flex items-center justify-between bg-unique"
            >
              <div>
                <h4 class="fs-6 fw-medium m-0">Unique</h4>
                <p class="m-0 fs-2 fw-medium text-primary">
                  {{ 100 - editorState.score }}%
                </p>
              </div>

              <circle-progress
                [percent]="100 - editorState.score"
                [outerStrokeWidth]="5"
                [innerStrokeWidth]="5"
                [outerStrokeColor]="'#08ba9c'"
                [innerStrokeColor]="'#d0e4d5'"
                [space]="-5"
                [showTitle]="false"
                [renderOnClick]="false"
                [units]="''"
                [radius]="25"
                [outerStrokeLinecap]="'square'"
                [clockwise]="false"
              ></circle-progress>
            </section>

            <!-- <div class="flex justify-between mt-3">
            <span class="fw-medium">Partial Matched</span>
            <div>
              <span class="pill pill-info">40%</span>
            </div>
          </div> -->

            <!-- <div class="progress-bar progress-bar-info">
            <div class="progress-bar-fill" style="width: 40%"></div>
          </div> -->
          </div>
        </div>
        <div
          class="flex-1 overflow-y-auto scrollable"
          *ngIf="editorState.content_id"
        >
          <h4 class="fs-6 p-base">View Plagiarized Sources</h4>
          <ul class="grid gap-default p-base py-0 list-style-none">
            @for (source of Object.keys(editorState.plagiarised); track source)
            {
            <li
              class="p-base border rounded results-accordion"
              [attr.data-target]="'HL_' + source + '-HTPD2M'"
            >
              <div
                class="w-full flex justify-between items-center result-header"
              >
                <div class="flex gap-default items-center">
                  <div>
                    <span class="pill pill-danger"
                      >{{
                        editorState.plagiarised[source].similarity_score.score
                      }}%</span
                    >
                  </div>
                  <span
                    >{{
                      editorState.plagiarised[source].similarity_score
                        .similar_words
                    }}
                    Similar Words</span
                  >
                  <!-- <span>
                <a
                  href="#"
                  class="btn-secondary px-2 rounded-lg source-link flex-inline gap-sm items-center py-1"
                >
                  <app-icons name="linkIcon"></app-icons>

                  <span class="source-url">
                    {{ siteTitle(editorState.plagiarised[source].webs[0].url) }}
                  </span>
                </a>
              </span> -->
                </div>

                <button
                  (click)="handleResultToggle($event)"
                  [attr.data-target]="'HL_' + source + '-HTPD2M'"
                >
                  <app-icons name="chevronDown"></app-icons>
                </button>
              </div>

              <section class="my-3 content">
                <!-- <h3 class="text-base">Countless journalists academics</h3> -->
                <p class="mb-4">
                  {{ editorState.plagiarised[source].query }}
                </p>

                <a
                  [href]="editorState.plagiarised[source].webs[0].url"
                  target="_blank"
                  class="btn-secondary px-2 rounded-lg flex-inline gap-sm items-center py-1"
                >
                  <app-icons name="linkIcon"></app-icons>

                  <span class="source-url">
                    {{ siteTitle(editorState.plagiarised[source].webs[0].url) }}
                  </span>
                </a>
              </section>
            </li>
            }
          </ul>
        </div>
      </div>
      <div
        class="p-base flex-1 text-lg overflow-y-auto container scrollable tab-screen"
        [ngClass]="{ relative: !editorEnabled }"
      >
        <div #editor spellcheck="false"></div>

        <section
          class="container absolute inset-0 p-base pt-4"
          [ngClass]="{ 'd-none': !(!editorEnabled && !editorState.words) }"
          (click)="renderEditor()"
          style="cursor: text"
        >
          <h4 class="mb-3" style="font-size: 20px">
            Type or paste (Ctrl+V) your text here.
          </h4>
          <p style="font-size: 16px">Or, upload a document.</p>
          <app-upload-file></app-upload-file>
        </section>
      </div>
      <div class="p-base container flex justify-between items-center gap-sm">
        <div class="flex gap-default items-center">
          <ul class="list-style-none m-0 p-0 flex gap-sm items-center">
            <!-- <li>
              <button
                class="btn-secondary flex gap-sm px-2 items-center rounded-lg"
              >
                <app-icons name="linkIcon"></app-icons>

                <span class="fw-medium">Check by URL</span>
              </button>
            </li> -->
            <li>
              <label
                for="exclude-url"
                class="exclude-url-label rounded-lg flex gap-sm mb-0"
              >
                <app-icons name="linkIcon"></app-icons>

                <input
                  type="url"
                  id="exclude-url"
                  placeholder="Exclude URL"
                  [(ngModel)]="exclude_url"
                />
              </label>
              <!-- <button
                class="btn-secondary flex gap-sm px-2 items-center rounded-lg"
              >
                <app-icons name="linkIcon"></app-icons>

                <span class="fw-medium">Exclude URL</span>
              </button> -->
            </li>
            <li class="text-body-tertiary">|</li>
          </ul>

          <ul class="list-style-none m-0 p-0 text-sm">
            <li>Words: {{ f(editorState.words) }}</li>
            <li>Characters: {{ f(editorState.characters) }}</li>
          </ul>
        </div>

        <div class="flex items-center gap-default">
          <ul class="list-style-none flex gap-default m-0 p-0">
            <li>
              <button
                class="btn-outline has-tooltip"
                (click)="copyToClipboard($event, quillEditor.getText())"
              >
                <app-icons name="copyIcon" />

                <span class="tooltip-content tooltip-top">Copy</span>
              </button>
            </li>
            <li>
              <button
                class="btn-outline has-tooltip"
                (click)="clearEditor($event)"
              >
                <app-icons name="clearIcon" />

                <span class="tooltip-content tooltip-top">Clear</span>
              </button>
            </li>
            <li class="download" *ngIf="editorState.content_id">
              <button
                class="btn-outline has-tooltip"
                (click)="downloadReport()"
              >
                <app-icons-free-tools name="downloadTabIcon" />

                <span class="tooltip-content tooltip-top">Download</span>
              </button>
            </li>
          </ul>
          <button
            class="check-grammar-btn"
            [ngClass]="{
              'check-grammar-btn-loading': editorState.state === 'loading'
            }"
            style="min-width: 196px"
            (click)="
              editorState.words < 30
                ? invokeModal($event)
                : handleCheckPlagiarism()
            "
            [disabled]="editorState.state === 'loading'"
            [attr.data-target]="'empty-content-modal'"
          >
            {{
              editorState.state === "loading" ? "Checking" : "Check Plagiarism"
            }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <aside
    class="h-screen flex flex-col"
    [ngClass]="{ collapsed: resultsCollapsed }"
  >
    <button
      class="results-panel-toggle flex gap-default items-center"
      (click)="resultsCollapsed = !resultsCollapsed"
    >
      <span
        class="transition-base pb-2px"
        [ngClass]="{ 'rotate-180': resultsCollapsed }"
      >
        <app-icons name="closeIcon" />
      </span>
    </button>

    <div class="p-base flex flex-col" *ngIf="editorState.content_id">
      <div class="flex gap-default mb-2">
        <button class="btn-dark flex-1" (click)="makeItUnique()">
          Make it Unique
        </button>
        <button class="btn-secondary flex-1" (click)="downloadReport()">
          Download Report
        </button>
      </div>
      <div
        class="grid gap-lg px-5 py-4 border rounded grid-cols-2"
        id="results"
      >
        <div>
          <section
            class="p-base border-danger rounded-lg flex items-center justify-between"
          >
            <div>
              <h4 class="fs-6 fw-medium m-0">Plagiarised</h4>
              <p class="m-0 fs-2 fw-medium text-danger">
                {{ editorState.score }}%
              </p>
            </div>

            <circle-progress
              [percent]="editorState.score"
              [outerStrokeWidth]="5"
              [innerStrokeWidth]="5"
              [outerStrokeColor]="'#e82d53'"
              [innerStrokeColor]="'#ffdddd'"
              [space]="-5"
              [showTitle]="false"
              [renderOnClick]="false"
              [units]="''"
              [radius]="25"
              [outerStrokeLinecap]="'square'"
            ></circle-progress>
          </section>

          <!-- <div class="flex justify-between mt-3">
            <span class="fw-medium">Exact Matched</span>
            <div>
              <span class="pill pill-warning">60%</span>
            </div>
          </div> -->

          <!-- <div class="progress-bar progress-bar-warning">
            <div class="progress-bar-fill" style="width: 60%"></div>
          </div> -->
        </div>
        <div>
          <section
            class="p-base border-primary rounded-lg flex items-center justify-between"
          >
            <div>
              <h4 class="fs-6 fw-medium m-0">Unique</h4>
              <p class="m-0 fs-2 fw-medium text-primary">
                {{ 100 - editorState.score }}%
              </p>
            </div>

            <circle-progress
              [percent]="100 - editorState.score"
              [outerStrokeWidth]="5"
              [innerStrokeWidth]="5"
              [outerStrokeColor]="'#08ba9c'"
              [innerStrokeColor]="'#d0e4d5'"
              [space]="-5"
              [showTitle]="false"
              [renderOnClick]="false"
              [units]="''"
              [radius]="25"
              [outerStrokeLinecap]="'square'"
              [clockwise]="false"
            ></circle-progress>
          </section>

          <!-- <div class="flex justify-between mt-3">
            <span class="fw-medium">Partial Matched</span>
            <div>
              <span class="pill pill-info">40%</span>
            </div>
          </div> -->

          <!-- <div class="progress-bar progress-bar-info">
            <div class="progress-bar-fill" style="width: 40%"></div>
          </div> -->
        </div>
      </div>
      <div class="mt-2 flex justify-between items-center">
        <h6 class="m-0">Show Matched Content</h6>

        <button
          class="btn-secondary px-3 rounded-lg flex items-center gap-default"
          [attr.data-target]="'content-analysis-modal'"
          (click)="invokeModal($event)"
        >
          <span>Content Analysis</span>

          <app-icons name="eyeIcon"></app-icons>
        </button>
      </div>
    </div>
    <div
      class="flex-1 overflow-y-auto scrollable"
      *ngIf="editorState.content_id"
    >
      <ul class="grid gap-default p-base py-0 list-style-none">
        @for (source of Object.keys(editorState.plagiarised); track source) {
        <li
          class="p-base border rounded results-accordion"
          [attr.data-target]="'HL_' + source + '-HTPD2M'"
        >
          <div class="w-full flex justify-between items-center result-header">
            <div class="flex gap-default items-center">
              <div>
                <span class="pill pill-danger"
                  >{{
                    editorState.plagiarised[source].similarity_score.score
                  }}%</span
                >
              </div>
              <span
                >{{
                  editorState.plagiarised[source].similarity_score.similar_words
                }}
                Similar Words</span
              >
              <!-- <span>
                <a
                  href="#"
                  class="btn-secondary px-2 rounded-lg source-link flex-inline gap-sm items-center py-1"
                >
                  <app-icons name="linkIcon"></app-icons>

                  <span class="source-url">
                    {{ siteTitle(editorState.plagiarised[source].webs[0].url) }}
                  </span>
                </a>
              </span> -->
            </div>

            <button
              (click)="handleResultToggle($event)"
              [attr.data-target]="'HL_' + source + '-HTPD2M'"
            >
              <app-icons name="chevronDown"></app-icons>
            </button>
          </div>

          <section class="my-3 content">
            <!-- <h3 class="text-base">Countless journalists academics</h3> -->
            <p class="mb-4">
              {{ editorState.plagiarised[source].query }}
            </p>

            <a
              [href]="editorState.plagiarised[source].webs[0].url"
              target="_blank"
              class="btn-secondary px-2 rounded-lg flex-inline gap-sm items-center py-1"
            >
              <app-icons name="linkIcon"></app-icons>

              <span class="source-url">
                {{ siteTitle(editorState.plagiarised[source].webs[0].url) }}
              </span>
            </a>
          </section>
        </li>
        }
      </ul>
    </div>

    <section
      class="h-full grid place-items-center"
      *ngIf="!editorState.content_id"
    >
      <app-empty-content content="content"></app-empty-content>
    </section>
  </aside>

  <app-modal parent="content-analysis-modal">
    <modal-content>
      <section class="flex justify-between items-center">
        <h3 class="m-0 fs-5 fw-bold">Content Analysis</h3>

        <button (click)="dismissModal($event)">
          <app-icons name="closeModalIcon"></app-icons>
        </button>
      </section>

      <ul
        class="grid gap-default mb-0 mt-4 p-0 fs-5 content-analysis-modal-list"
      >
        <li class="flex justify-between items-center">
          <span>Syllables</span>
          <span>210</span>
        </li>
        <li class="flex justify-between items-center">
          <span>Unique Words</span>
          <span>74 (61%)</span>
        </li>
        <li class="flex justify-between items-center">
          <span>Avg Word Length (char)</span>
          <span>4.8</span>
        </li>
        <li class="flex justify-between items-center">
          <span>Difficult Words</span>
          <span>36 (36%)</span>
        </li>
        <li class="flex justify-between items-center">
          <span>Sentences</span>
          <span>5</span>
        </li>
        <li class="flex justify-between items-center">
          <span>Paragraphs</span>
          <span>3</span>
        </li>
        <li class="flex justify-between items-center">
          <span>Syllables per Word</span>
          <span>1.7</span>
        </li>
      </ul>
    </modal-content>
  </app-modal>

  <app-modal parent="content-exceeds-words-limit-modal">
    <modal-content>
      <section class="text-center grid justify-center">
        <h3>Content Exceeds Words Limit</h3>

        <p>
          Please reduce your content to less than
          {{ f(authLimits[authState].words) }} words.
        </p>

        <div>
          <button
            class="check-grammar-btn w-unset"
            (click)="dismissModal($event)"
            style="max-width: unset !important"
          >
            Dismiss
          </button>
        </div>
      </section>
    </modal-content>
  </app-modal>

  <app-modal parent="empty-content-modal">
    <modal-content>
      <section class="text-center grid justify-center">
        <h3>Enter at least 30 words.</h3>

        <p>Please enter at least 30 words to proceed.</p>

        <div>
          <button
            class="check-grammar-btn w-unset"
            (click)="dismissModal($event)"
            style="max-width: unset !important"
          >
            Dismiss
          </button>
        </div>
      </section>
    </modal-content>
  </app-modal>
</main>
